import { render, staticRenderFns } from "./PredictionConfig.vue?vue&type=template&id=078e53a0&"
import script from "./PredictionConfig.vue?vue&type=script&lang=js&"
export * from "./PredictionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports